/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Preview_DescriptionInputs */



/**
* | output |
* | --- |
* | "Assembled from your instructions and the choices above. Always English, because it is sent to the model." |
*
* @param {Agent_Builder_Preview_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_preview_description = /** @type {((inputs?: Agent_Builder_Preview_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Preview_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wird aus Ihren Anweisungen und den Angaben oben zusammengesetzt. Immer auf Englisch, da es an das Modell gesendet wird.")
	return /** @type {LocalizedString} */ ("Assembled from your instructions and the choices above. Always English, because it is sent to the model.")
});